// `<turbo-stream action="reload_frame" target="…">`: refetches each target frame from its own
// `src`. Unlike replacing the frame, the current content stays until the new answer arrives, so a
// lazily computed figure (the capacity board's Auslastungsleiste) refreshes after a mutation
// without flashing its placeholder. A target that is not a turbo-frame (no reload) is skipped.
export function reloadFrame() {
  this.targetElements.forEach((element) => {
    if (typeof element.reload === "function") element.reload()
  })
}
